import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getSegmentsService } from '../services/segments.service';
import { TSegmentsReqParams } from '../types/segments.types';

export const useGetSegmentsDataQuery = (
  counterpartyGUID: string,
  params?: TSegmentsReqParams,
  options?: any
): UseQueryResult<any> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.SegmentsQueryKeys].getSegmentsData(counterpartyGUID, params),
    ...options
  });

export const useGetSegmentsMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string, params?: TSegmentsReqParams }) =>
      getSegmentsService(data.counterpartyGUID, data.params),
  });
